import { createBrowserHistory } from 'history';
import _ from 'lodash';
import config from '../config';

export const history = createBrowserHistory(); //https://github.com/ReactTraining/react-router/blob/master/FAQ.md#how-do-i-access-the-history-object-outside-of-components

history.listen(location => {
  // eslint-disable-next-line @typescript-eslint/camelcase
  gtag('config', config.gaTrackingId, { page_path: location.pathname });
});

//this method store SearchParam during redirect
export const redirect = (
  path: string,
  params?: { name: string; value: string }[]
) => {
  const urlSearchParams = new URLSearchParams(history.location.search);
  _.forEach(params, p => urlSearchParams.append(p.name, p.value));
  history.push(path + '?' + urlSearchParams);
};

export const getSearchParam = (key: string) => {
  const urlSearchParams = new URLSearchParams(history.location.search);
  return urlSearchParams.get(key);
};

export const redirectToAuth = () => {
  const signInPatch = '/signIn';
  if (history.location.pathname !== signInPatch) {
    history.push(signInPatch);
  }
};

/**
 * Listen to anchor updates.
 * @param onAnchor Callback for when anchor changes
 * @param callImmediately If this flag is set, the callback will be called immediately if anchor is not empty.
 */
export const anchorListener = (
  onAnchor: (name: string) => void,
  callImmediately: boolean = true
): (() => void) => {
  if (callImmediately) {
    const name = history.location.hash.replace('#', '');
    if (name.length > 0) {
      onAnchor(name);
    }
  }
  return history.listen(location => {
    const { hash } = location;
    if (hash !== '') {
      // Push onto callback queue so it runs after the DOM is updated,
      // this is required when navigating from a different page so that
      // the element is rendered on the page before trying to getElementById.
      setTimeout(() => {
        const name = hash.replace('#', '');
        if (name.length > 0) {
          onAnchor(name);
        }
      }, 0);
    }
  });
};

export const pathListener = (
  onPath: (path: string) => void,
  onlyWhenEmptyHash: boolean = true
): (() => void) => {
  return history.listen(location => {
    const { hash, pathname } = location;
    if (onlyWhenEmptyHash && !_.isEmpty(hash)) {
      return;
    }
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
      onPath(pathname);
    }, 0);
  });
};
